import { ROUTE_NAME } from '@constants';
const facility = {
  path: '/facility',
  redirect: '/facility/clubhouse',
  name: ROUTE_NAME.Facilities,
  meta: {
    breadcrumb: true,
    breadcrumbName: '시설안내',
  },
  children: [
    // {
    //   name: ROUTE_NAME.Lobby,
    //   path: 'lobby',
    //   alias: 'lobby',
    //   component: () => import('@views/facility/Lobby.vue'),
    //   meta: {
    //     isReady: false,
    //     breadcrumb: true,
    //     breadcrumbName: '클럽하우스',
    //   },
    // },
    // {
    //   name: ROUTE_NAME.StartHouse,
    //   path: 'starthouse',
    //   alias: 'starthouse',
    //   component: () => import('@views/facility/StartHouse.vue'),
    //   meta: {
    //     isReady: false,
    //     breadcrumb: true,
    //     breadcrumbName: '스타트하우스',
    //   },
    // },
  ],
};
export default facility;
